// removed by extract-text-webpack-plugin
module.exports = {"font-header":"App-module__font-header__1NbuQ","fontHeader":"App-module__font-header__1NbuQ","font-primary":"App-module__font-primary__oevMu","fontPrimary":"App-module__font-primary__oevMu","font-secondary":"App-module__font-secondary__2oLW6","fontSecondary":"App-module__font-secondary__2oLW6","sr-only":"App-module__sr-only__31GCI","srOnly":"App-module__sr-only__31GCI","sr-only-important":"App-module__sr-only-important___OgMJ","srOnlyImportant":"App-module__sr-only-important___OgMJ","App":"App-module__App__UQ1zV","app":"App-module__App__UQ1zV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/App/App.module.scss
// module id = 803
// module chunks = 0